import { useEffect, useState } from 'react';
import { cnDate, cnTime } from '@wd/shared';

// 服务器时间可能被开发时钟拨过，前端以服务器为准
let offsetMs = 0;

export function syncServerClock(serverNowIso: string) {
  offsetMs = new Date(serverNowIso).getTime() - Date.now();
}

export function serverNow(): Date {
  return new Date(Date.now() + offsetMs);
}

/** 每分钟刷新一次的“现在” */
export function useNow(intervalMs = 30_000): Date {
  const [now, setNow] = useState(serverNow);
  useEffect(() => {
    const t = setInterval(() => setNow(serverNow()), intervalMs);
    return () => clearInterval(t);
  }, [intervalMs]);
  return now;
}

export const todayCN = () => cnDate(serverNow());
export const timeCN = (d: Date | string) => cnTime(typeof d === 'string' ? new Date(d) : d);
